import type {PermissionsRecordType} from '../permissions';

export const tireInventoryPermissions = {
  readTireInventory: {
    resourceId: 'TIRE_ORDER',
    actionId: 'READ',
    scopes: [],
  },
  readTireWarehouse: {
    resourceId: 'TIRE_WAREHOUSE',
    actionId: 'READ',
    scopes: ['TIRE_WAREHOUSE'],
  },
  createTireOrder: {
    resourceId: 'TIRE_ORDER',
    actionId: 'CREATE',
    scopes: ['BRANCH', 'BRANCH_SPECIFIC'],
  },
  createTireSet: {
    resourceId: 'TIRE_SET',
    actionId: 'CREATE',
    scopes: [],
  },
  editTireSet: {
    resourceId: 'TIRE_SET',
    actionId: 'EDIT',
    scopes: ['BRANCH', 'BRANCH_SPECIFIC'],
  },
} satisfies PermissionsRecordType;
